import { css } from '@emotion/react';

import * as React from 'react';

import { OverflowCarousel } from '@coursera-web/cds-labs';

import { useVisibilityTracker } from '@coursera/event-pulse/react';

import Section from 'bundles/front-page/components/Section';
import PartnerLogo from 'bundles/front-page/redesign-modules/partner-logos/PartnerLogo';
import getPartnerData from 'bundles/front-page/redesign-modules/partner-logos/getPartnerData';

import _t from 'i18n!nls/front-page';

const styles = {
  pills: css`
    display: flex;
    gap: var(--cds-spacing-100);
    flex-wrap: nowrap;
  `,
};

/**
 * Displays interactive partner logos / names within an overflow carousel.
 */
const PartnerLogosModuleRenderer = () => {
  const partnerData = getPartnerData();

  const visibilityTrackerRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_page_section',
    {
      pageSection: {
        sectionName: 'partner_logo_list',
      },
    }
  );

  return (
    <Section title={_t('Learn from 350+ leading universities and companies')}>
      <div ref={visibilityTrackerRef}>
        <OverflowCarousel css={styles.pills} shouldAllowSpaceForHoverItems shouldStartOverflowAtMediumBreakpoint>
          {partnerData.map((partner) => (
            <PartnerLogo key={partner.name} name={partner.name} logo={partner.logo} href={partner.href} />
          ))}
        </OverflowCarousel>
      </div>
    </Section>
  );
};

export default PartnerLogosModuleRenderer;
